import firebase from "firebase/app";
//import * as firebase from "firebase"
import "firebase/auth";
import "firebase/database"
const app=firebase.initializeApp({
    apiKey: "AIzaSyCMQUiDCIFIftR3I2IzNUy6UY5saC-JH2M",
    authDomain: "reacttestdev.firebaseapp.com",
    databaseURL: "https://reacttestdev-default-rtdb.firebaseio.com",
    projectId: "reacttestdev",
    storageBucket: "reacttestdev.appspot.com",
    messagingSenderId: "206622517942",
    appId: "1:206622517942:web:d5120e7d074c98d5065417"
});

export const auth=app.auth();
export default app.database().ref(); 